import { Component, Input, ViewChild } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { MatStepper } from '@angular/material/stepper';
import { SettingsService } from '../../settings/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IdInversorService } from '../services/id-inversor.service';
import { SharedDataService } from '../services/shared-data.service';
import { TablaInversionesComponent } from '../tabla-inversiones/tabla-inversiones.component';
import { ChartInstitucionComponent } from '../chart-institucion/chart-institucion.component';
import { ChartGananciaComponent } from '../chart-ganancia/chart-ganancia.component';
import { ChartProyeccionComponent } from '../chart-proyeccion/chart-proyeccion.component';
import { EventService } from '../services/event.service';

export interface PeriodicElement {
  key: string;
  value: any;
}

export interface PeriodicElement2 {
  key2: string;
  mensual?: any;
  anual?: any;
  colspan?: number;
}

@Component({
  selector: 'app-resultado-simulacion',
  standalone: true,
  imports: [MaterialModule, CommonModule, TablaInversionesComponent, ChartInstitucionComponent, ChartGananciaComponent, ChartProyeccionComponent],
  templateUrl: './resultado-simulacion.component.html',
  styleUrl: './resultado-simulacion.component.less'
})
export class ResultadoSimulacionComponent {
  @ViewChild(TablaInversionesComponent) tablaInversionesComponent!: TablaInversionesComponent;
  
  @Input() isPublicSimulation!: boolean;
  @Input() stepper!: MatStepper;
  @Input() parent:any;

  displayedColumns: string[] = ['key', 'value'];
  displayedColumns2: string[] = ['key2', 'mensual', 'anual'];

  dataSource: PeriodicElement[] = [
    { key: 'Cliente', value: '' },
    { key: 'Correo', value: '' },
    { key: 'Fecha emisión', value: '' },
    { key: 'Fecha vencimiento', value: '' },
    { key: 'Días al vencimiento', value: '' },
  ];

  dataSource2: PeriodicElement2[] = [
    { key2: 'Tasa', mensual: '', anual: '' },
    { key2: 'Spread real', mensual: '', anual: '' },
    { key2: 'Ganancia al vencimiento', mensual: '', anual: '', colspan: 2 },
  ];

  constructor(
    private settings: SettingsService,
    public snackBar: MatSnackBar,
    private idInversorService: IdInversorService,
    private sharedDataService: SharedDataService,
    private eventService: EventService
  ) {}

  ngOnInit(): void {
    this.getSimulacionData();
    
    this.eventService.formSubmitted$.subscribe(() => {
      this.getSimulacionData();
    });
  }

  loading: boolean = true;

  async getSimulacionData() {
    this.loading = true;
    try {
      const investorId = this.idInversorService.getIdInversor();
      if (investorId) {
        const bd: any = await this.settings.get_query(1, `/cliente-inversionista/simulation/${investorId}/`, {} , true);

        console.log("augele", bd)
        const body_data = bd._body.info.data.investor_header;
  
        
  
        const formattedIssueDate = this.formatDate(body_data.issue_date);
        const investorDetails = bd._body.info.data.investor_details;
        const lastElement = investorDetails[investorDetails.length - 1];
        const formattedLastDate = this.formatDate(lastElement.date);
        const profitAmount = lastElement.simpli_amount;
    
    
        this.dataSource = [
          { key: 'Cliente', value: body_data.name || '' },
          { key: 'Correo', value: body_data.mail || '' },
          { key: 'Fecha emisión', value: formattedIssueDate || '' },
          { key: 'Fecha vencimiento', value: formattedLastDate || '' },
          { key: 'Días al vencimiento', value: body_data.time_limit || '' },
        ];
  
        this.dataSource2 = [
          { key2: 'Tasa',
            mensual: body_data.rate ? parseFloat((body_data.rate * 100).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '', 
            anual: body_data.rate ? parseFloat((body_data.rate * 100 * 12).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' },
          { key2: 'Spread real', 
            mensual: body_data.spread ? parseFloat((body_data.spread * 100).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '', 
            anual: body_data.spread ? parseFloat((body_data.spread * 100 * 12).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' },
          { key2: 'Ganancia al vencimiento', 
            anual: profitAmount, 
            colspan: 2 },
        ];
  
        this.sharedDataService.setSimulacionData(bd._body.info.data);
  
        
      } else {
        console.error('ID no válido.');
      }
    } catch (error) {
      console.error('Error al obtener datos de simulación:', error);
    } finally {
      this.loading = false;
    }
  }


  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
  }

  formatMoney = (amount: any, decimalCount = 2, decimal = ",", thousands = ".") => {
    try {
      if (amount === 0 || amount === '-') {
        return '-'; 
      }
  
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
      return '';
    }
  }

  goToPreviousStep(){
    if(this.parent){
      this.parent.subStep = 2;
      this.parent.step = 1;
      this.parent.previousStep();

    }else{
      if (this.tablaInversionesComponent) {
        this.tablaInversionesComponent.resetDataSource();
      }

      this.dataSource.forEach(item => {
        item.value = '';
      });
  
      this.dataSource2.forEach(item => {
        item.mensual = ''; 
        item.anual = '';   
      });
      this.stepper.previous(); 
    }

  }

  enviandoBtn: boolean = false;

  async sendPdf() {
    this.enviandoBtn = true;

    try {
      const investorId = this.idInversorService.getIdInversor();
      if (investorId) {
        const response: any = await this.settings.get_query(2, `/cliente-inversionista/simulation-email/${investorId}/`,{});
        const body_data = response._body;

        if(this.parent){
            this.parent.step = 3;
        }else{
          this.stepper.next();
        }
        this.enviandoBtn = false;
 
      } else {
        console.error('ID de inversor no válido.');
      }
    } catch (error) {
      console.error('Error en la solicitud para enviar el PDF:', error);
      this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
        duration: 20000,
        panelClass: 'simpli-snack'
      });
    } finally {
      this.enviandoBtn = false;
    }
  }
  
}
